import RequestBuilder from '../Lib/Requests';
import Moment from 'moment';

export default class EventService {
  api = new RequestBuilder();

  buildEventDatapointRequest({
    gatewayID,
    datapointID,
    last = false,
    limit = 200,
    dateStart = Moment().subtract(4, 'h').valueOf(),
    dateStop = null,
    cancelToken,
  }) {
    const lastString = last ? '/last' : '';
    const conditionalLimit = last ? {} : { limit };
    return {
      service: 'gateway',
      endpoint: `/gateway/${gatewayID}/datapoint/${datapointID}/events${lastString}`,
      method: 'get',
      params: { dateStart, dateStop, ...conditionalLimit },
      cancelToken,
    };
  }

  getEventDatapoints = async (params) => {
    const { data = {} } = await this.api.request(
      this.buildEventDatapointRequest(params)
    );
    return data;
  };

  buildExportEventsToCSVRequest(gatewayID, data, params, cancelToken) {
    return {
      service: 'gateway',
      endpoint: `/gateway/${gatewayID}/datapoint/export`,
      method: 'post',
      data,
      params,
      cancelToken,
    };
  }

  exportEventsToCSV = async (gatewayID, dateBody, params, cancelToken) => {
    const { data = {} } = await this.api.request(
      this.buildExportEventsToCSVRequest(
        gatewayID,
        dateBody,
        params,
        cancelToken
      )
    );
    return data;
  };

  buildFetchEventsForSignalsOnMapRequest({
    assetID,
    datapointID,
    cancelToken,
    ...params
  }) {
    return {
      service: 'gateway',
      endpoint: `/gateway/${assetID}/datapoint/${datapointID}/events`,
      method: 'get',
      params,
      cancelToken,
    };
  }
  async fetchEventsForSignalsOnMap(params) {
    const { data = {} } = await this.api.request(
      this.buildFetchEventsForSignalsOnMapRequest(params)
    );
    return data;
  }
}
